// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import { Card, Typography, message } from 'antd';
import SankeyContainer from '../../../components/sankey/SankeyContainer';
import SankeySelector from '../../../components/sankey/SankeySelector';
import { getDefaultDateRange } from '../../../services/sankeyService';

const { Title, Text } = Typography;

const SankeyGraphTab = () => {
  const [selection, setSelection] = useState({
    type: null,
    id: null,
    name: ''
  });

  const handleSelectionChange = (newSelection) => {
    setSelection(newSelection);
    
    if (newSelection.id) {
      message.success(`${newSelection.type === 'proyecto' ? 'Proyecto' : 
                       newSelection.type === 'elemento' ? 'Elemento' : 'Tarjeta'} 
                       "${newSelection.name}" seleccionado`);
    }
  };

  const getDefaultParams = () => {
    const defaultRange = getDefaultDateRange();
    return {
      fechaInicio: defaultRange.fechaInicio,
      fechaFin: defaultRange.fechaFin,
      unidades: []
    };
  };

  const getTypeDisplayName = (type) => {
    switch (type) {
      case 'proyecto':
        return 'Proyecto';
      case 'elemento':
        return 'Elemento';
      case 'tarjeta':
        return 'Tarjeta';
      default:
        return '';
    }
  };

  return (
    <div style={{ padding: '1rem' }}>
      <div style={{ marginBottom: '2rem' }}>
        <Title level={3} style={{ margin: 0, color: '#001529' }}>
          📊 Análisis de Flujo de Datos - Gráficas Sankey
        </Title>
        <Text type="secondary" style={{ fontSize: '1rem', marginTop: '0.5rem', display: 'block' }}>
          Visualiza el flujo de datos desde sensores hasta la jerarquía organizacional con diferentes niveles de análisis.
        </Text>
      </div>

      <SankeySelector onSelectionChange={handleSelectionChange} />

      {selection.id && (
        <Card 
          style={{ 
            marginTop: '1.5rem',
            border: '2px solid #f0f0f0',
            borderRadius: '12px',
            overflow: 'hidden'
          }}
          bodyStyle={{ padding: 0 }}
        >
          <div style={{
            background: 'linear-gradient(135deg, #001529 0%, #002140 100%)',
            padding: '1.5rem',
            color: 'white'
          }}>
            <Title level={4} style={{ margin: 0, color: 'white' }}>
              Análisis Sankey - {getTypeDisplayName(selection.type)}: {selection.name}
            </Title>
            <Text style={{ color: 'rgba(255,255,255,0.8)', marginTop: '0.5rem', display: 'block' }}>
              Mostrando flujo de datos para el {selection.type} seleccionado con filtros personalizables
            </Text>
          </div>
          
          <div style={{ padding: '1.5rem' }}>
            <SankeyContainer
              type={selection.type}
              id={selection.id}
              title={`Flujo de datos - ${selection.name}`}
              showControls={true}
              initialParams={getDefaultParams()}
              controlsConfig={{
                showUnidadesFilter: true,
                showDateControl: true
              }}
            />
          </div>
        </Card>
      )}

      {!selection.id && (
        <Card 
          style={{ 
            marginTop: '1.5rem',
            textAlign: 'center',
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
          }}
        >
          <div style={{ 
            padding: '3rem',
            color: '#6c757d'
          }}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem', opacity: 0.3 }}>
              
            </div>
            <Title level={3} type="secondary" style={{ margin: '0 0 1rem 0' }}>
              ¡Comienza tu Análisis Sankey!
            </Title>
            <Text type="secondary" style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
              Selecciona el tipo de análisis y el elemento específico que deseas analizar.<br/>
              Las gráficas Sankey te mostrarán el flujo completo de datos desde los sensores<br/>
              hasta los diferentes niveles organizacionales.
            </Text>
            
            <div style={{ 
              marginTop: '2rem',
              padding: '1.5rem',
              backgroundColor: 'white',
              borderRadius: '8px',
              border: '1px solid #e9ecef',
              display: 'inline-block'
            }}>
              <Title level={5} style={{ margin: '0 0 1rem 0', color: '#495057' }}>
                Tipos de Análisis Disponibles
              </Title>
              <div style={{ textAlign: 'left' }}>
                <div style={{ marginBottom: '0.5rem' }}>
                  <strong>📁 Proyecto:</strong> <Text type="secondary">Análisis completo de todo el proyecto</Text>
                </div>
                <div style={{ marginBottom: '0.5rem' }}>
                  <strong>🔧 Elemento:</strong> <Text type="secondary">Análisis específico por elemento</Text>
                </div>
                <div>
                  <strong>💳 Tarjeta:</strong> <Text type="secondary">Análisis por tarjeta de control</Text>
                </div>
              </div>
            </div>
          </div>
        </Card>
      )}
    </div>
  );
};

export default SankeyGraphTab;